import { getRunningEnv } from './env-helper';

let baidutongjiID = '';

const initBaiduStatistics = () => {
  initBaiduId();
  creatScript();
}

function initBaiduId () {
  if (getRunningEnv() === 'GOVPRD') {
    // 生产环境
		baidutongjiID = '44995e4e3cb0b5565119c31ff7d69186';
  } else {
    // 测试环境
		baidutongjiID = '30c59c205efbddfcc915c1a0f791fd8f';
  }
}

function creatScript () {
  window._hmt = window._hmt || [];
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = `https://hm.baidu.com/hm.js?${baidutongjiID}`;
  document.body.appendChild(script);
}

export {
  initBaiduStatistics
}
